module.exports = __webpack_public_path__ + "static/img/ross_noble_ani_extended_size_00038-fs8.e422bde.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/animation/ross_noble_ani_extended_size_00038-fs8.png
// module id = 191
// module chunks = 0